/* global attributesInfoData */
jQuery(document).ready(function ($) {
  if (!$('body').hasClass('single-product')) {
    return;
  }
  const loveItSelect = require('./love-it-select');
  const selectElementToBeUsed = $('select');
  loveItSelect.init(selectElementToBeUsed);

  /**
   * Remove duplicate price for variable products (after variation was selected)
   **/
  const productVariationsForm = $('form.variations_form');
  productVariationsForm.on('show_variation', function( event, data ){
    $('.elementor-widget-woocommerce-product-price').hide();
  });
  productVariationsForm.on('hide_variation', function(){
    $('.elementor-widget-woocommerce-product-price').show();
  });

  /**
   * Custom product-tabs
   **/
  $('.custom-wc-tab').on('click', toggleTab);

  function toggleTab() {
    $(this).toggleClass('active');
    if ($(this).hasClass('active')) {
      $(this).children('.custom-wc-tabs__panel').slideDown();
    } else {
      $(this).children('.custom-wc-tabs__panel').slideUp();
    }
  }

  /**
   * Product-attributes info-popup
   **/
  initiateAttributesInfoPopups();

  function initiateAttributesInfoPopups() {
    const attrData = typeof attributesInfoData !== 'undefined' && attributesInfoData ? attributesInfoData : null;
    if (!attrData || !Object.keys(attrData).length) {
      return;
    }

    Object.keys(attrData).forEach((attrSlug) => {
      const attrMessage = attrData[attrSlug];
      const productAttributeLabelElement = '#' + attrSlug;
      $(productAttributeLabelElement).parent().append(get_popup_html(attrSlug, attrMessage));

      setTimeout(() => {
        $(productAttributeLabelElement).on('click', function () {
          $('#info-popup-' + attrSlug).toggle();
        });
        $('#trigger-info-popup-' + attrSlug).on('click', function () {
          $('#info-popup-' + attrSlug).toggle();
        });
      }, 100);
    });

    const productVariationsSelect = $('.variations select');
    productVariationsSelect.on('click', function () {
      $('.single-product-attributes-info-popup').hide();
    });
  }

  function get_popup_html(slug, message) {
    return '<div id="trigger-info-popup-' + slug + '" class="single-product-attributes-info-icon elementor-icon">'
      + '<svg aria-hidden="true" class="e-font-icon-svg e-fas-info-circle" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"></path></svg>'
      + '<div id="info-popup-' + slug + '" class="single-product-attributes-info-popup" style="display: none;">'
      + message
      + '</div></div>';
  }
});
